import React from 'react';
export const BlurView = <></>;
